import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { Loader2, ArrowRight, Eye } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function TeamLogin() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setBusy(true);
    try {
      const res = await api.post("/auth/login", { email, password });
      setUser(res.data.user);
      navigate("/dashboard");
    } catch (err) {
      const d = err?.response?.data?.detail;
      setError(typeof d === "string" ? d : "Sign in failed. Please try again.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center px-6">
      <div className="w-full max-w-md">
        <Link to="/" className="flex items-center justify-center gap-2.5 mb-8">
          <img src="/brand/jca-matrix-logo.png" alt="JCA Matrix™" className="h-9 w-auto" />
        </Link>
        <div className="rounded-2xl border border-slate-200 bg-white p-8 shadow-sm" data-testid="team-login-card">
          <h1 className="font-display text-xl font-semibold tracking-tight text-slate-900">Team access</h1>
          <p className="mt-1.5 text-sm text-slate-500">Restricted to authorized MarksMan accounts.</p>
          <form onSubmit={submit} className="mt-6 space-y-4">
            <div>
              <label className="text-xs font-semibold uppercase tracking-widest text-slate-500">Email</label>
              <Input data-testid="login-email-input" type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
                placeholder="you@marksmanhealthcare.com" className="mt-1.5 h-11 rounded-lg" />
            </div>
            <div>
              <label className="text-xs font-semibold uppercase tracking-widest text-slate-500">Password</label>
              <Input data-testid="login-password-input" type="password" required value={password} onChange={(e) => setPassword(e.target.value)}
                placeholder="••••••••" className="mt-1.5 h-11 rounded-lg" />
            </div>
            {error && <p data-testid="login-error" className="text-sm text-red-600">{error}</p>}
            <Button data-testid="login-submit-btn" type="submit" disabled={busy}
              className="w-full h-11 rounded-lg bg-blue-600 hover:bg-blue-700 text-white font-medium">
              {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <>Sign in <ArrowRight className="ml-2 h-4 w-4" /></>}
            </Button>
          </form>
        </div>
        <p className="mt-6 text-center text-xs text-slate-400 flex items-center justify-center gap-1.5">
          <Eye className="h-3.5 w-3.5" /> Access is limited to authorized MarksMan team accounts.
        </p>
      </div>
    </div>
  );
}
